module.exports = __webpack_public_path__ + "static/media/suit-spades.ddc82a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/suit-spades.png
// module id = 136
// module chunks = 0